export const headersAsset = [
  "Id",
  "Número",
  "Tipo",
  "Criado",
  "Estado",
  "Cidade",
  "Ativo em"
]

export const headersOrder = [
  "Protocolo",
  "Número",
  "Tipo",
  "Criado",
  "Estado",
  "Cidade",
  "Status",
  "Observações"
]

export const optionsActionsOrders = [
  "Reagendar portabilidade",
  "Suspender portabilidade",
  "Exportar protocolos",
  "Cancelar portabilidade"
]

export const optionsActionsAssets = ["Editar cliente", "Exportar números"]



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/ClientDetails/ClientNumbers/constants.js